/**
 * Image Map — frontend interactivity.
 *
 * Hover (desktop): show label, dim other markers.
 * Tap (mobile): toggle label on tap, close on outside tap.
 * Focus (keyboard): show label on focus.
 */
( function imageMapInit() {

	'use strict';

	const ACTIVE_CLASS = 'b-image-map__marker--active';
	const HAS_ACTIVE_CLASS = 'b-image-map--has-active';

	/**
	 * Initialize a single image-map block.
	 *
	 * @param {HTMLElement} block The block root element.
	 */
	function initImageMap( block ) {

		const container = block.querySelector( '.b-image-map__container' );
		if ( ! container ) {

			return;

		}

		const markers = container.querySelectorAll( '.b-image-map__marker' );
		if ( ! markers.length ) {

			return;

		}

		let activeMarker = null;

		/**
		 * Activate a marker (show label, dim others).
		 *
		 * @param {HTMLElement} marker The marker element.
		 */
		function activate( marker ) {

			if ( activeMarker && activeMarker !== marker ) {

				deactivate( activeMarker );

			}
			marker.classList.add( ACTIVE_CLASS );
			container.classList.add( HAS_ACTIVE_CLASS );
			activeMarker = marker;

		}

		/**
		 * Deactivate a marker.
		 *
		 * @param {HTMLElement} marker The marker element.
		 */
		function deactivate( marker ) {

			marker.classList.remove( ACTIVE_CLASS );
			if ( activeMarker === marker ) {

				activeMarker = null;

			}
			if ( ! container.querySelector( `.${  ACTIVE_CLASS}` ) ) {

				container.classList.remove( HAS_ACTIVE_CLASS );

			}

		}

		/**
		 * Deactivate all markers.
		 */
		function deactivateAll() {

			markers.forEach( function clearMarker( m ) {

				m.classList.remove( ACTIVE_CLASS );

			} );
			container.classList.remove( HAS_ACTIVE_CLASS );
			activeMarker = null;

		}

		markers.forEach( function bindMarker( marker ) {

			// Desktop hover
			marker.addEventListener( 'mouseenter', function handleEnter() {

				activate( marker );

			} );

			marker.addEventListener( 'mouseleave', function handleLeave() {

				deactivate( marker );

			} );

			// Mobile tap
			marker.addEventListener( 'click', function handleClick( e ) {

				e.preventDefault();
				e.stopPropagation();

				if ( marker.classList.contains( ACTIVE_CLASS ) ) {

					deactivate( marker );

				} else {

					activate( marker );

				}

			} );

			// Keyboard focus
			marker.addEventListener( 'focus', function handleFocus() {

				activate( marker );

			} );

			marker.addEventListener( 'blur', function handleBlur() {

				deactivate( marker );

			} );

		} );

		// Close on outside click/tap
		document.addEventListener( 'click', function handleOutsideClick( e ) {

			if ( activeMarker && ! e.target.closest( '.b-image-map__marker' ) ) {

				deactivateAll();

			}

		} );

	}

	// Initialize all image-map blocks on the page.
	/**
	 * Init all blocks.
	 */
	function init() {

		const blocks = document.querySelectorAll( '.b-image-map' );
		blocks.forEach( initImageMap );

	}

	if ( document.readyState === 'loading' ) {

		document.addEventListener( 'DOMContentLoaded', init );

	} else {

		init();

	}

}() );
